import {WritableStream} from 'web-streams-polyfill/ponyfill';
import streamSaver from 'streamsaver';
import {timeUtil} from "../component/common/session/utils/time";

const {timeToStringFormat} = timeUtil;

export const downloadIndex = (session) => {
  console.log('downloadIndex');
  const parsedTimeNotes = session.timenote ? JSON.parse(session.timenote) : []

  // If the WritableStream is not available (Firefox, Safari), take it from the polyfill
  if (!window.WritableStream) {
    streamSaver.WritableStream = WritableStream;
    window.WritableStream = WritableStream;
  }
  let fileName = 'index.csv';
  console.log("Use ["+fileName+"] as fileName");

  /*const fileStream = streamSaver.createWriteStream(fileName);
  window.writer = fileStream.getWriter();
  window.writer.write('ciao');
  window.writer.close();
  */
  console.log(parsedTimeNotes);
  const items = parsedTimeNotes;

  const header = Object.keys(parsedTimeNotes);
  const replacer = (key, value) => value === null ? '' : value; // specify how you want to handle null values here
  
  const csv = [
    ...items.map(row => [row['evento']['name'], row['speaker'], timeToStringFormat(row['time']), row['url']].join(','))
  ].join('\r\n')

 
  console.log(csv);
  const url = window.URL.createObjectURL(
    new Blob([csv]),
  );
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute(
    'download',
    fileName,
  );
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
}


export const downloadFile = (fileUrl, customName) => {
  const splitted1 = fileUrl.split('.');
  const splitted2 = (splitted1[splitted1.length - 2] + '.' + splitted1[splitted1.length - 1]).split('/');
  let fileName = splitted2[splitted2.length - 1];
  if(customName){
	fileName = customName+"."+ splitted1[splitted1.length - 1];
	console.debug("Use ["+fileName+"] as fileName");
  }
  fetch(fileUrl, {
    method: 'GET',
  })
    .then(response => {

      // These code section is adapted from an example of the StreamSaver.js
      // https://jimmywarting.github.io/StreamSaver.js/examples/fetch.html

      // If the WritableStream is not available (Firefox, Safari), take it from the polyfill
      if (!window.WritableStream) {
        streamSaver.WritableStream = WritableStream;
        window.WritableStream = WritableStream;
      }

      const fileStream = streamSaver.createWriteStream(fileName);
      const readableStream = response.body;

      // More optimized
      if (readableStream.pipeTo) {
        return readableStream.pipeTo(fileStream);
      }

      window.writer = fileStream.getWriter();

      const reader = response.body.getReader();
      const pump = () => reader.read()
        .then(res => res.done
          ? window.writer.close()
          : window.writer.write(res.value).then(pump));

      pump();
    })
    .catch(error => {
      console.log(error);
    });
  ;
};

export function _downloadFile(fileURL) {
  const fileSplitted = fileURL.split('/')
  const fileName = fileSplitted[fileSplitted.length - 1];

  fetch(fileURL, {
    method: 'GET',
  })
    .then((response) => response.blob())
    .then((blob) => {

      const url = window.URL.createObjectURL(
        new Blob([blob]),
      );
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        fileName,
      );
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    });
}
